import { defineComponent as t, computed as s, createBlock as a, openBlock as r, withCtx as n, createVNode as d, renderSlot as l } from "vue";
import u from "./IntroductionCard.vue.js";
import c from "./IntroductionLayout.vue.js";
const L = /* @__PURE__ */ t({
  __name: "InfoBlock",
  props: {
    id: {},
    layout: {},
    oasVersion: {},
    getOriginalDocument: { type: Function },
    info: {},
    externalDocs: {},
    documentExtensions: {},
    infoExtensions: {},
    isLoading: { type: Boolean },
    onLoaded: { type: Function }
  },
  setup(e) {
    const i = s(
      () => e.layout === "classic" ? "after" : "aside"
    );
    return (o, m) => (r(), a(c, {
      id: o.id,
      documentExtensions: o.documentExtensions,
      externalDocs: o.externalDocs,
      getOriginalDocument: o.getOriginalDocument,
      info: o.info,
      infoExtensions: o.infoExtensions,
      isLoading: o.isLoading,
      oasVersion: o.oasVersion,
      onLoaded: o.onLoaded
    }, {
      [i.value]: n(() => [
        d(u, {
          row: o.layout === "classic"
        }, {
          default: n(() => [
            l(o.$slots, "selectors")
          ]),
          _: 3
        }, 8, ["row"])
      ]),
      _: 2
    }, 1032, ["id", "documentExtensions", "externalDocs", "getOriginalDocument", "info", "infoExtensions", "isLoading", "oasVersion", "onLoaded"]));
  }
});
export {
  L as default
};
